import { createStyles, Fade, makeStyles, SnackbarContent, Theme } from '@material-ui/core';
import React from 'react';

type Props = {
  shouldShowConfirmation: boolean;
};

export const CloseConfirmation = ({ shouldShowConfirmation }: Props): React.ReactElement => {
  const classes = useStyles();

  return (
    <Fade in={shouldShowConfirmation}>
      <div className={classes.closeConfirmationContainer}>
        <SnackbarContent className={classes.closeConfirmation} message={'Click again or press ESC to exit.'} />
      </div>
    </Fade>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeConfirmationContainer: {
      zIndex: theme.zIndex.appBar,
      position: 'absolute',
      height: '100%',
      width: '100%',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      pointerEvents: 'none',
    },
    closeConfirmation: {
      opacity: 0.5,
    },
  })
);
